export enum AnyizeType {
    ANY_REPAINT = 'ANY_REPAINT',
    ANY_STEP = 'ANY_STEP',
    ANY_PAGE = 'ANY_PAGE',
}
